import useHostPartnerQuery from 'data/signup/use-host-partner-query';

export default function useHasSinglePartnership(): boolean {
	const { isSuccess, data } = useHostPartnerQuery();

	if ( ! isSuccess ) {
		return false;
	}

	return Object.keys( data.host_partner?.partnerships ?? [] ).length === 1;
}
